module.exports = __webpack_public_path__ + "img/exp_3.5f98342f.png";